<template>
  <div class="layout-container">
    <!-- 顶部导航栏：整体是一张图片 -->
    <div class="header">
      <div class="header-bg"></div>
      <div class="header-inner">
        <!-- 左侧 Logo 图片 -->
        <div class="logo">
          <img src="@/assets/logo.png" alt="优成科技" />
        </div>

        <!-- 右侧导航菜单 -->
        <el-menu
          :default-active="activeMenu"
          mode="horizontal"
          background-color="transparent"
          text-color="#ffffff"
          active-text-color="#ffffff"
          router
          class="nav-menu"
        >
          <el-menu-item index="/home">网站首页</el-menu-item>
          <el-menu-item index="/about">关于我们</el-menu-item>
          <el-menu-item index="/webbuild">网站建设</el-menu-item>
          <el-menu-item index="/mobileapp">手机应用</el-menu-item>
          <el-menu-item index="/wechatmarketing">微信营销</el-menu-item>
          <el-menu-item index="/hardwaredev">硬件开发</el-menu-item>
        </el-menu>
      </div>
    </div>

    <!-- 路由出口 -->
    <router-view></router-view>

    <!-- 底部 -->
    <div class="footer">
      <img src="@/assets/foot.png" alt="底部背景" />
      <div class="icp">
        Copyright ◎ 2015 优成科技 版权所有
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">苏ICP备15053306号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  data() {
    return {
      activeMenu: '/home'
    }
  },
  watch: {
    $route(to) {
      this.activeMenu = to.path
    }
  },
  mounted() {
    this.activeMenu = this.$route.path
  }
}
</script>

<style scoped>
.layout-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}


/* 顶部导航图片容器 */
.header {
  position: relative;
  width: 100%;
  height: 80px;
  flex-shrink: 0;
  background: #3081ed;
  box-sizing: border-box;
  padding: 20px 58px;
  color: #fff;
  border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}



.header-inner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 58px;
}

/* 左侧 Logo */
.logo img {

  display: block;
      width: 141px;
    height: 42px;
}

/* 右侧菜单 */
.nav-menu {
  border-bottom: none;
  background: transparent;
}

.nav-menu ::v-deep .el-menu-item {
  color: #fff;
  font-size: 18px;
  height: 80px;
  line-height: 80px;
  padding: 0 22px;
  background: transparent;
  border-bottom: none;
}

/* 激活项：严格按图片显示白色短下划线 */
.nav-menu ::v-deep .el-menu-item.is-active {
  color: #fff;
  background: transparent;
  border-bottom: none;
  position: relative;
}

.nav-menu ::v-deep .el-menu-item.is-active::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 18px;
  transform: translateX(-50%);
  width: 56%;
  height: 3px;
  background-color: #ffffff;
}

/* 去掉 ElementUI 默认激活背景 */
.nav-menu  .el-menu-item:hover,
.nav-menu .el-menu-item:focus {
  background: transparent !important;
}

/* 底部 */
.footer {
  position: relative;
  margin-top: auto;
}

.footer img {
  width: 100%;
  display: block;
}

.icp {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  color: #686868;
  font-size: 14px;
}

.icp a {
  color: inherit;
  text-decoration: none;
  margin-left: 6px;
}
</style>
